var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "push_config" },
    [
      !_vm.isMob
        ? _c("div", { staticClass: "notice_bar" }, [
            _vm._v(
              "\n    注意：" +
                _vm._s(_vm.channelName) +
                "的“AppKey、Master Secret”是" +
                _vm._s(_vm.channelName) +
                "推送服务的关键参数，同时用于本系统的【一键登录】功能。\n    "
            ),
            _c(
              "span",
              { staticClass: "jump_link", on: { click: _vm.jumpTutorial } },
              [_vm._v("推送具体注册和配置教程>>")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "section_title" }, [_vm._v("应用凭证")]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm1",
          staticClass: "config_form",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.isMob ? "mob AppKey" : "App Key",
                        prop: _vm.fieldKeys.appKey,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          autocomplete: "off",
                          name: "off-app-key",
                        },
                        model: {
                          value: _vm.ruleForm[_vm.fieldKeys.appKey],
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, _vm.fieldKeys.appKey, $$v)
                          },
                          expression: "ruleForm[fieldKeys.appKey]",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.isMob ? "mob MasterSecret" : "Master Secret",
                        prop: _vm.fieldKeys.secret,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          "show-password": "",
                          autocomplete: "new-password",
                          name: "off-master-secret",
                        },
                        model: {
                          value: _vm.ruleForm[_vm.fieldKeys.secret],
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, _vm.fieldKeys.secret, $$v)
                          },
                          expression: "ruleForm[fieldKeys.secret]",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm1")
                    },
                  },
                },
                [_vm._v("保存配置信息")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }